import { format, setHours, setMinutes, setSeconds, subDays } from "date-fns";
import moment from "moment";
import { LectureData } from "Pages/MyScheduleBeta/LectureDetails/LectureTypes";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
enum Direction {
  "Unmarked" = "Unmarked",
  "Marked" = "Marked",
  "Delayed" = "Delayed",
  "Upcoming" = "Upcoming",
  "Ongoing" = "Ongoing",
}

export const todayDates = moment().utcOffset("+05:30").format().split("T")[0];
export const past7Days = format(
  setSeconds(setMinutes(setHours(subDays(new Date(), 5), 18), 30), 0),
  "yyyy-MM-dd"
);
export function truncateLecture(str: string, length: number): string {
  if (!str) return "";
  const lastHyphenIndex = str?.lastIndexOf("-");

  if (lastHyphenIndex === -1) {
    return str.substring(0, length);
  }

  const prefix = str.substring(0, lastHyphenIndex);
  const suffix = str.substring(lastHyphenIndex); // includes '-'

  return prefix.substring(0, length) + suffix;
}
export const getTruncateLectureWithWidth = (
  str: string,
  width: number
): string => {
  switch (width) {
    case 33:
      return truncateLecture(str, 3);
    case 50:
      return truncateLecture(str, 3);
    default:
      return str;
  }
};
const colorMap: Record<Direction, string> = {
  [Direction.Unmarked]: "badge badge-aeslProofread",
  [Direction.Marked]: "badge badge-success",
  [Direction.Delayed]: "badge badge-aeslReview",
  [Direction.Upcoming]: "badge badge-Upcoming",
  [Direction.Ongoing]: "badge badge-aeslPublish",
};
export const getColorCodeByLectureStatus = (status: Direction) => {
  return colorMap[status] || "badge badge-aeslDraft";
};
export const lectureColorMap: Record<Direction, string> = {
  [Direction.Unmarked]: "#705010",
  [Direction.Marked]: "#0b442d",
  [Direction.Delayed]: "#b32306",
  [Direction.Upcoming]: " #572ac8",
  [Direction.Ongoing]: "#008dc4",
};
export const getBatchName = (batchName: string) => {
  const BATCHNAME_ARRAY = batchName.split("-");
  return BATCHNAME_ARRAY.length ? BATCHNAME_ARRAY[1] : "";
};
export const getColorCodeLecture = (status: Direction) => {
  return lectureColorMap[status];
};
export const checkValidation = (
  userInfo: IUserInfo,
  cardViewData: LectureData
) => {
  const dateViewDatas = moment(cardViewData?.endTime)
    .utcOffset("+05:30")
    .format()
    .split("T")[0];
  const time = moment(cardViewData?.endTime);

  let retVal = false;
  if (userInfo?.fexRole == "Faculty" && dateViewDatas == todayDates) {
    retVal = false;
  } else if (
    userInfo?.fexRole != "Faculty" &&
    (time.isBetween(past7Days, todayDates) || dateViewDatas == todayDates)
  ) {
    retVal = false;
  } else {
    retVal = true;
  }
  return retVal;
};
